import { makeStyles, Typography, Grid, TextField, Button, Container, Paper } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import React, { useState } from 'react'
import { useAuth } from '../../../contexts/AuthContext';


const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
        alignItems: 'center'
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(3),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}));

export default function Profile() {
    const classes = useStyles();
    const auth = useAuth();
    const [name, setName] = useState(auth?.currentUser?.displayName || '');
    const [email, setEmail] = useState(auth?.currentUser?.email || '');
    const [phoneNumber, setPhoneNumber] = useState(auth?.currentUser?.phoneNumber || '');
    const [error, setErrorMessage] = useState('');
    const [success, setSuccessMessage] = useState('');

    const handleUpdateProfile = async (e: any) => {
        e.preventDefault();
        setSuccessMessage('');
        setErrorMessage('');
        try {
            if (name.trim()) {
                await auth?.updateDisplayName(`${name}`);
                // await auth?.updateEmail(email);
                setSuccessMessage('Profile updated!');
            } else {
                setErrorMessage("Some fields are empty!");
            }
        } catch (e) {
            setErrorMessage("Something went wrong!! Please try again.");
            console.error(e);
        }
    }

    return (
        <Container maxWidth="lg" className={classes.container}>
            <Paper className={classes.paper}>
                {
                    success && <Alert severity="success">{success}</Alert>
                }
                {
                    error && <Alert severity="error">{error}</Alert>
                }
                <Typography component="h1" variant="h5">
                    Update Profile
                </Typography>
                <form className={classes.form} noValidate>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                autoComplete="fname"
                                name="firstName"
                                variant="outlined"
                                required
                                fullWidth
                                id="firstName"
                                label="Display Name"
                                autoFocus
                                value={name}
                                onChange={e => setName(e.target.value)}
                                disabled={(auth?.currentUser?.displayName) ? true : false}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                variant="outlined"
                                required
                                fullWidth
                                id="email"
                                label="Email Address"
                                name="email"
                                autoComplete="email"
                                disabled
                                value={email}
                                onChange={e => setEmail(e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                variant="outlined"
                                required
                                fullWidth
                                id="phone"
                                label="Phone"
                                name="phone"
                                autoComplete="phone"
                                disabled
                                value={phoneNumber}
                                onChange={e => setPhoneNumber(e.target.value)}
                            />
                        </Grid>
                    </Grid>
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                        className={classes.submit}
                        onClick={handleUpdateProfile}
                        disabled={(auth?.currentUser?.displayName) ? true : false}
                    >
                        Update
                    </Button>
                </form>

            </Paper>
        </Container>
    )
}
